/* eslint-disable max-len */
/* eslint-disable max-lines */
import * as packageInfo from '../../package.json';
import { InstallmentType } from '@ux/entities/installment-types';

const _version = packageInfo;

export const ENV = {
  version: _version.version,
  urlPath: 'https://viajes.dev.rappi.com',
  webview_auth: 'dev',
  production: false,
  defaultLocale: 'es-CO',
  missingKey: false,
  localeCMS: 'co',
  language: 'ES',
  branchcode: 'APP1',
  business_unit_code: '2',
  x_application_id: '123',
  user_service: 'rappi',
  domain_checkout: 'dev.rappi.com',
  desktop_checkout: 'https://www.dev.rappi.com/checkout',
  web_login: 'https://www.dev.rappi.com/login?url_redirect={redirect}',
  footer_operated_by: 'Operado por Travel Moustache SAS -  NIT 901337236-7.  Dir. Notificaciones Calle 71A # 14-27, Bogotá. <span class="OPERATED_BY_OPEN_CERT CO_RNT_79000">RNT 79000.</span>',
  proxy_images: 'https://microservices.dev.rappi.com/api/ms/travel-imageproxy',
  rappipro_deeplink: 'gbrappi://com.grability.rappi?goto=prime_modal&source=rappi_home_banner&type=prime_native_inapp',
  rappipro_link: 'https://pro.rappi.com/',
  currency_precision: 0,
  is_enable_travel_city_autoComplete: true,
  travel_city_limit: 10,
  use_cookies_auth: false,
  resources: {
    base_lambda_img: 'https://images.rappi.com'
  },
  covid_location_restrict: [],
  calendar_users_days_prime: 0,
  repentance_link: 'https://rappi.kustomer.help/contact/arrepentimiento-de-compra-B19z0_n0_',
  repentance_link_desktop: 'https://rappi.kustomer.help/contact/arrepentimiento-de-compra-B19z0_n0_',
  btn_repentance: false,
  validate_search: {
    flighs: {
      calendar_days_limit: 2,
      calendar_users_days_limit: [
        { id: 19114786, days: 1 },
        { id: 17121926, days: 1 }
      ],
      open_search: false,
      international_dates: {
        minDate: '2020/03/01',
        maxDate: ''
      },
      national_dates: {
        minDate: '2020/03/01',
        maxDate: ''
      },
      AR: {
        international_dates: {
          minDate: '2020/03/01',
          maxDate: '2020/09/01'
        },
        national_dates: {
          minDate: '2020/03/01',
          maxDate: '2020/09/01'
        }
      }
    },
    hotels: {
      calendar_days_limit: 2,
      calendar_users_days_limit: [
        { id: 19114786, days: 1 },
        { id: 17121926, days: 1 }
      ],
      open_search: true,
      international_dates: {
        minDate: '',
        maxDate: ''
      },
      national_dates: {
        minDate: '',
        maxDate: ''
      }
    },
    buses: {
      calendar_days_limit: 2,
      calendar_users_days_limit: [
        { id: 19114786, days: 1 },
        { id: 17121926, days: 1 }
      ],
      open_search: true,
      international_dates: {
        minDate: '',
        maxDate: ''
      },
      national_dates: {
        minDate: '',
        maxDate: ''
      }
    },
    autos: {
      calendar_days_limit: 2,
      calendar_users_days_limit: [
        { id: 19114786, days: 1 },
        { id: 17121926, days: 1 }
      ],
      open_search: true,
      international_dates: {
        minDate: '',
        maxDate: ''
      },
      national_dates: {
        minDate: '',
        maxDate: ''
      }
    }
  },
  countryModules: {
    booking: {
      call_support: true,
      exchange_rate: {
        enabled: false,
        currency_to: null,
        currency_to_name: null,
        show_currency_sufix: false
      },
      go_to_pay_button: {
        enabled_price_info: true
      }
    },
    user_history: {
      exchange: true,
      can_do_payment: true,
      disabled_airlines_exchange: [
        'LA', 'JA', 'JZ', 'WJ'
      ],
      seatMap: true
    },
    cancellation: {
      hotel_enabled: true,
      flight_enabled: true,
      disabled_by_airlines: [
        'VH', 'VV', 'JA', 'JZ', 'WJ', 'P5', 'VB'
      ]
    },
    header: {
      show_disabled_products: false,
    },
    show_select_class: true,
    installments: {
      partner_type: InstallmentType.CARDS,
    },
    airlines_local_policies_info: {
      'VE': 'https://www.easyfly.com.co/',
      '9R': 'https://www.satena.com/',
      'LA': 'https://www.latamairlines.com/',
      'AD': 'https://www.voeazul.com.br/mobile/home',
      'G3': 'https://www.voegol.com.br/pt',
      'VH': 'https://www.vivaair.com/'
    },
    banner_results: {
      banner_enabled_flighs: true,
      banner_enabled_hotels: true,
      banner_enabled_autos: true,
      banner_enabled_air_packages: true,
      banner_enabled_buses: true,
      banner_flights_available: 'RAPPI_CARD',
      banner_hotels_available: 'RAPPI_CARD',
      banner_byhours_available: 'RAPPI_CARD',
      banner_autos_available: 'RAPPI_CARD',
      banner_air_packages_available: 'RAPPI_CARD',
      banner_buses_available: 'RAPPI_CARD',
      cashback: {
        flights: {
          total: 5, card: 3, credits: 2, references: [2141299407],
          product_cashback: {
            VW: {
              total: 10, card: 3, credits: 7, references: [2134826808]
            },
            AM: {
              total: 10, card: 3, credits: 7, references: [2141299407]
            }
          }
        },
        hotels: { total: 5, card: 3, credits: 5, references: [2141299407] },
        autos: { total: 5, card: 3, credits: 5, references: [2141299407] },
        air_packages: {
          total: 5, card: 3, credits: 5, references: [2141299407],
          product_cashback: {
            VW: {
              total: 10, card: 3, credits: 7, references: [2134826808]
            },
            AM: {
              total: 10, card: 3, credits: 7, references: [2141299407]
            }
          }
        },
        buses: { total: 5, card: 5, credits: 5, references: [2141299407] },
      }
    },
    taxes_on_results: {
      mobile: { flights: '', hotels: '' },
      desktop: { flights: '', hotels: '' }
    },
  },
  countryInfo: {
    name: 'Colombia',
    phone_prefix: '+57',
    iso_code: 'CO',
    currency_code: 'COP',
    icon: 'https://images.rappi.com/web/countries-flags/co.webp',
    facebook: 'https://www.facebook.com/RappiColombia/',
    twitter: 'https://twitter.com/rappicolombia?lang=es',
    instagram: 'https://www.instagram.com/rappicolombia/?hl=es',
    locale: 'es-CO',
    show_currency_sufix: true,
    country_id: 1,
    support_phone: '601 5800699',
    whatsapp_help_message: '¡Hola! necesito ayuda sobre el itinerario',
    inquiriesAndComplains: null,
    complaints_book: null,
    footer_pdf: null,
    minutes_to_restart_searches: 25,
    displayTUA: false,
    tzIdentifier: 'America/Bogota'
  },
  default_address: {
    active: true,
    city: null,
    description: '',
    address: 'Cl. 93 #19-58 [Bogotá]',
    lat: 4.6097100,
    lng: -74.0817500,
    other: '',
    tag: 'default'
  },
  header_redirect: {
    link: 'https://www.rappi.com.co/',
    title: 'rappi.com.co'
  },
  footer_links: {
    restaurants: 'https://www.rappi.com.co/restaurantes',
    markets: 'https://www.rappi.com.co/aliados/tipo/market',
    courier: 'https://www.rappi.com.co/courier-hours',
    travel: '/',
    terms_rappi: 'https://legal.rappi.com/colombia/terminos-y-condiciones-de-uso-de-plataforma-rappi-2/',
    terms_netactica: '/terms',
    data_treatment_rappi:
      'https://legal.rappi.com/colombia/politica-de-proteccion-y-tratamiento-de-datos-personales-rappi-s-a-s/',
    data_treatment_netactica: '/private-policy',
    data_right_repentance_rappi: '/right-repentance',
    aerocivil: 'https://www.aerocivil.gov.co/',
    blog: 'http://blog.rappi.com/',
    rappitendero: 'https://soyrappi.com/?utm_source=appuser&utm_medium=applk&utm_campaign=rt',
    rappibusiness: 'http://www.rappibusiness.com',
    job: 'https://jobs.rappi.com',
    rappione: 'https://one.rappi.com/',
    register_restaurant: 'https://rappi.typeform.com/to/KuGxg2',
    subscription_terms: 'http://www.rappibusiness.com/promociones/2019/7/10/trminos-y-condiciones-suscripcin-mundo-alpina',
    sic: 'https://www.sic.gov.co/'
  },
  api: {
    services: 'https://microservices.dev.rappi.com',
    travel_flight_content: 'https://microservices.dev.rappi.com',
    server: 'https://v2.dev.rappi.com',
    netactica: 'https://preprod.servicesnet.agency/netcoreapi', // Reemplazar cuando el ambiente este estable por https://preprod.netactica.com/
    images: 'https://preprod.netactica.com/Images',
    search: 'https://microservices.dev.rappi.com',
    travel_data_info: 'https://microservices.dev.rappi.com/api/ms/travel-data-info',
    travel_order_billing: 'https://microservices.dev.rappi.com/api/ms/travel-order-billing',
    travel_alerts: 'https://microservices.dev.rappi.com/api/ms/travel-alerts',
    travel_static_content: 'https://microservices.dev.rappi.com/api/travel-static-content-ms',
    travel_cms: 'https://microservices.dev.rappi.com/api/travel-content-admin-ms',
    ip: 'https://api.ipify.org',
    static_search_hotel_autocomplete: 'https://microservices.dev.rappi.com/api/travel-hotel-search',
    lifemiles_integration: 'https://microservices.dev.rappi.com/api/ms/loyalty-notification'
  },
  booking_options: {
    burned_data: {
      fiscal_responsibility: null
    }
  },
  app_ios: {
    link: 'https://itunes.apple.com/co/app/rappi/id984044296?mt=8',
    name: 'App Store'
  },
  app_android: {
    link: 'https://play.google.com/store/apps/details?id=com.grability.rappi',
    name: 'Play Store'
  },
  coming_soon_images: {
    experiences: 'https://staticuestudio.blob.core.windows.net/buhomag/2016/11/18134917/poner-a-prueba.jpg',
    flight_and_hotels: 'https://static.comunicae.com/photos/notas/1205626/1560841533_Cancelaciones_verano_1_.jpg'
  },
  store_configuration: {
    STORE_TYPE: 'viajes',
    VERTICAL_GROUP: 'rappitravel',
    VERTICAL_SUB_GROUP: 'viajes',
    STORE_ID: 900101672,
    STORE_NAME: 'Rappi Travel',
    SUPPORT_LINK: 'gbrappi://com.grability.rappi?goto=chat&chat_type=non_live_chat&chat_key=HC_NO_RELATED_TO_ORDERS',
    WHATSAPP_SUPPORT_LINK: 'https://wa.me/5713285584',
    WHATSAPP_SUPPORT_APP_LINK: 'whatsapp://send?phone=5713285584',
  },
  available_locales: {
    co: 'es-CO',
    br: 'pt-BR',
    mx: 'es-MX',
    ar: 'es-AR',
    cl: 'es-CL',
    uy: 'es-UY',
    pe: 'es-PE',
    ec: 'es-EC',
    cr: 'es-CR'
  },
  chubb_terms_pdf: 'https://rappi-images-upload-co.s3.amazonaws.com/web/travel/Chubb/PDF/clausulado-rappi-full-20211104.pdf',
  chubb_insured_sum_age: false,
  animation: {
    url: '/assets/libs/ngx-lottie/CO/WAITING_FEE.json',
    options: {
      width: '85vw',
      height: 'auto',
      maxWidth: '85vw',
      maxHeight: 'auto',
      marginLeft: '0px'
    }
  },
  statsigKey: 'secret-mnxOXHySTSxVn26JDBXopnCr3Vf6GF7flM6TZWYGRR8',
  avoKey: 'RrjSp3lT9jrLSG0mgcZk',
  loyaltyClientID: 'dHJhdjMxQXAxSzN5'
};
